import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'uke-ui/lib/locale/en' // uke-ui lang
import elementZhLocale from 'uke-ui/lib/locale/zh-CN'// uke-ui lang
import enLocale from './en'
import zhLocale from './zh'
import zhError from './zh-error'
import zhValidate from './zh-validate'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...zhError,
    ...zhValidate,
    ...elementZhLocale
  }
}

const i18n = new VueI18n({
  locale: 'zh', // set locale
  messages // set locale messages
})

export default i18n
